import { IonCol, IonContent, IonGrid, IonHeader, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import './Tab2.css';

import User from "../components/ListCollection/User"

const Tab2: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Tab 2</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Tab 2</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonGrid>

        <div className="mg-65"/>

        <IonRow>
            <IonCol size="12" className="p-0 p-md-1">
                <User hide={false} />
            </IonCol>
          </IonRow>


        </IonGrid>

      </IonContent>
    </IonPage>
  );
};

export default Tab2;
